module.exports = __webpack_public_path__ + "static/bnr_square@2x-e3c2bafea57629ad07435ff0058509f7.webp";